/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react'

import { Oval } from 'react-loader-spinner'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { InputLabel, OutlinedInput } from '@mui/material'
import ArrowForward from '@mui/icons-material/ArrowForward'

import PasswordInput from '../inputs/PasswordInput'
import { AppSettingsContext } from '../../App'
import { setRefreshToken, setToken } from '../../useToken'
import useRole from '../../useUserRole'
import { login } from '../../api/login'
import { setSystemMessage } from '../../features/systemMessageSlice'

import {
  StyledButton,
  StyledErrorMessage,
  StyledForm,
  StyledFormControl,
  styledLoading,
  StyledTitle,
} from '../../styles/components/LoginFormStyle'

const LoginForm = () => {
  const [loginData, setLoginData] = useState({ username: '', password: '' })
  const [errorMessage, setErrorMessage] = useState({
    username: '',
    password: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const { setUserRole } = useRole()
  const { setIsLoggedIn } = useContext(AppSettingsContext)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target
    setLoginData({
      ...loginData,
      [name]: value,
    })
  }

  const isValidInput = () => {
    let newErrorMessage = { username: '', password: '' }

    newErrorMessage =
      loginData.username === ''
        ? { ...newErrorMessage, username: 'Enter your username' }
        : { ...newErrorMessage, username: '' }

    newErrorMessage =
      loginData.password === ''
        ? { ...newErrorMessage, password: 'Enter your password' }
        : { ...newErrorMessage, password: '' }

    setErrorMessage(newErrorMessage)
    return newErrorMessage.password === '' && newErrorMessage.username === ''
  }

  const handleLogin = async (e) => {
    e.preventDefault()

    if (isValidInput()) {
      setIsLoading(true)
      await login(loginData.username, loginData.password)
        .then((res) => {
          const userRole = res?.data.role.name
          const userToken = res?.data.access
          const refreshToken = res?.data.refresh
          const username = res?.data.username

          userRole && setUserRole(userRole)

          if (userToken && refreshToken) {
            setToken(userToken)
            setRefreshToken(refreshToken)
            username && sessionStorage.setItem('username', username)
            setIsLoggedIn(true)
            setIsLoading(false)

            userRole === 'admin' ? navigate('/table', { replace: true }) : navigate('/statistics', { replace: true })
          }
        })
        .catch((error) => {
          setIsLoading(false)
          if (error.response) {
            setErrorMessage({ ...errorMessage, password: 'Invalid username or password' })
          } else if (error.request) {
            dispatch(
              setSystemMessage({
                message: 'Server is not responding, please try again later',
                severity: 'error',
              })
            )
          } else {
            dispatch(setSystemMessage({ message: error.message, severity: 'error' }))
          }
        })
    }
  }

  return (
    <StyledForm onSubmit={handleLogin} method="POST">
      <StyledTitle variant="h1">Gordon Web App</StyledTitle>
      <StyledFormControl variant="outlined">
        <InputLabel htmlFor="outlined-adornment-password">Username</InputLabel>
        <OutlinedInput
          label="Username"
          variant="outlined"
          onChange={handleChange}
          value={loginData.username}
          name="username"
          data-cy="input-login-name"
        />
        {errorMessage.username !== '' && (
          <StyledErrorMessage aria-label="usernameValidation">{errorMessage.username}</StyledErrorMessage>
        )}
      </StyledFormControl>
      <StyledFormControl variant="outlined">
        <PasswordInput
          handleChange={handleChange}
          name="password"
          value={loginData.password}
          errorMessage={errorMessage.password}
          autocomplete={true}
        />
      </StyledFormControl>
      <StyledButton
        variant="contained"
        endIcon={
          isLoading ? (
            <Oval type="TailSpin" color="white" height={10} width={10} style={styledLoading} />
          ) : (
            <ArrowForward />
          )
        }
        type="submit"
        data-cy="input-login-submit"
      >
        Log in
      </StyledButton>
    </StyledForm>
  )
}

export default LoginForm
